import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { RecipeSearchResult } from "../models/recipe-search-result.model";
import { ReferenceIntakeProfile } from '../models/reference-intake-profile';
import { Settings } from '../models/Settings';
import { Tag } from "../models/tag";
import { NavItem } from "../models/nav-item.model";

@Injectable({
  providedIn: "root",
})
export class FoodPortalStateService {

  subdomain: string;
  customerGroupId: number;

  openMenu$ = new Subject<any>();

  recipes: RecipeSearchResult[];
  portalSettings: Settings;

  /** The set of navigation menu items, if configured */
  navItems: NavItem[] | null;

  referenceIntakeProfile = new BehaviorSubject<ReferenceIntakeProfile>(null);

  recipeList = {
    searchText: "",
    pageSize: 10
  }

  /** Returns a flattened array of all tags used in all tag groups */
  public get allTags(): Tag[] {
    return this.portalSettings.tagGroups.reduce((prev, current) => [...prev, ...current.tags], [] as Tag[]);
  }

  public createNavigation(): void {
    const navItems = this.portalSettings.navItems;
    if (!navItems) return;

    const allRecipeIds = this.recipes.map(x => x.id);

    navItems.forEach(ni => {
      ni.recipeIds = ni.recipeIds.filter(x => allRecipeIds.includes(x));
    });

    this.navItems = navItems.filter(x => x.recipeIds.length);
    if (!this.navItems.length) this.navItems = null;
  }

  public selectedNavItem: NavItem | null = null;

}
